// src/components/CustomNotificationContainer.js
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import notificationBus from '../../events/notificationBus';
import { Alert } from 'antd';

const CustomNotificationContainer = () => {
  const [notifications, setNotifications] = useState([]);
  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    // Create a dedicated container that's guaranteed to be at the top level
    const container = document.createElement('div');
    container.id = 'notification-portal-container';
    container.style.cssText = `
      position: fixed !important;
      top: 10px !important;
      right: 20px !important;
      z-index: 10001 !important;
      max-width: 400px !important;
      pointer-events: none !important;
      width: auto !important;
    `;
    document.body.appendChild(container);
    setPortalContainer(container);

    // Cleanup function
    return () => {
      if (container && document.body.contains(container)) {
        document.body.removeChild(container);
      }
    };
  }, []);

  useEffect(() => {
    const handler = ({ type, message, description }) => {
      const id = Date.now();
      setNotifications((prev) => [
        ...prev,
        { id, type, message, description },
      ]);
      // Longer duration for better visibility (8 seconds)
      setTimeout(() => {
        setNotifications((prev) => prev.filter((x) => x.id !== id));
      }, 8000);
    };

    notificationBus.on('notify', handler);
    return () => notificationBus.off('notify', handler);
  }, []);

  // Don't render anything until portal container is ready
  if (!portalContainer) {
    return null;
  }

  // Render notifications directly to the portal container
  return createPortal(
    <>
      {notifications.map((n) => (
        <Alert
          key={n.id}
          type={n.type}
          message={n.message}
          description={n.description}
          closable
          onClose={() =>
            setNotifications((prev) => prev.filter((x) => x.id !== n.id))
          }
          style={{
            marginBottom: '12px',
            width: '100%',
            pointerEvents: 'auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            borderRadius: '6px',
            animation: 'slideInRight 0.3s ease-out'
          }}
        />
      ))}
    </>,
    portalContainer
  );
};

export default CustomNotificationContainer;
